export enum CookiesKey {
    USER_COOKIE = "UserCookie",
    JWT_TOKEN = "JwtToken",
    USER_CLAIMS = "UserClaims",
    ACCESS_ROLE = "AccessRole"
}

export enum LayoutType {
    COMMON_LAYOUT = 0,
    ADMIN_LAYOUT = 1,
    USER_LAYOUT = 2,
}

export type svgType = React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
    }
>;
